import React, { createContext, useContext, useState } from "react";

interface SuccessContextType {
  messages: string[];
  addSuccess: (msg: string) => void;
  removeSuccess: (index: number) => void;
  topSuccess: string | null;
  setSuccess: (msg: string | null) => void;
}

const SuccessContext = createContext<SuccessContextType | undefined>(undefined);

export const SuccessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [messages, setMessages] = useState<string[]>([]);
  const [topSuccess, setTopSuccess] = useState<string | null>(null);

  const addSuccess = (msg: string) => setMessages((prev) => [...prev, msg]);
  const removeSuccess = (index: number) =>
    setMessages((prev) => prev.filter((_, i) => i !== index));
  const setSuccess = (msg: string | null) => setTopSuccess(msg);

  return (
    <SuccessContext.Provider value={{ messages, addSuccess, removeSuccess, topSuccess, setSuccess }}>
      {children}
    </SuccessContext.Provider>
  );
};

export const useSuccess = () => {
  const ctx = useContext(SuccessContext);
  if (!ctx) throw new Error("useSuccess must be used within a SuccessProvider");
  return ctx;
};